export default __webpack_public_path__ + "028027ec44890e91b45c42d495c1530a.png";